import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import LineChart from './../../../../../../../chartUtilities/lineChart/lineChart';
import Loader from './../../../../../../../utilityComponents/Loader';
import Message from './../../../../../../../utilityComponents/Message';
import PropTypes from 'prop-types'


function LongitudinalJerkKPI(props) {
    return (
        <Container>
            { props.loading ? <Loader /> :
                props.error ? (
                    <Message variant={'danger'}>
                        {props.error}
                    </Message>
                ) : (
                    <>
                        <Row>
                            <Col md={12} xl={12}>
                                <h4>Longitudinal Jerk</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} xl={12}>
                                <Container>
                                    { (props.longitudinalJerk.xAxis.length === 0 &&
                                        props.longitudinalJerk.yAxis.length === 0) ?
                                         (<Message variant={'info'}>No Data Available</Message>) : (
                                            <LineChart
                                                title={'Longitudinal Jerk'}
                                                xAxisTitle={'Time (s)'}
                                                yAxisTitle={'Longitudinal Jerk (m/s^3)'}
                                                xAxis={props.longitudinalJerk.xAxis}
                                                yAxis={props.longitudinalJerk.yAxis}
                                            />
                                         )}
                                </Container>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} xl={12}>
                                <h4>Longitudinal Jerk KPI Pass/Fail Flag</h4>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} xl={12}>
                                <Container>
                                    { (props.kpiPass.xAxis.length === 0 &&
                                        props.kpiPass.yAxis.length === 0) ?
                                        (<Message variant={'info'}>No Data Available</Message>) : (
                                            <LineChart
                                                title={'Longitudinal Jerk KPI Pass/Fail Flag'}
                                                xAxisTitle={'Time (s)'}
                                                yAxisTitle={'KPI Flag'}
                                                xAxis={props.kpiPass.xAxis}
                                                yAxis={props.kpiPass.yAxis}
                                            />
                                        ) }
                                </Container>
                            </Col>
                        </Row>
                    </>
                )}
        </Container>
    )
}

LongitudinalJerkKPI.propTypes={
    loading:PropTypes.bool,
    error:PropTypes.string,
    longitudinalJerk:PropTypes.object,
    kpiPass:PropTypes.object
}

const mapStateToProps = (state) => ({
    loading: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.loading,
    error: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.error,
    longitudinalJerk: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.longitudinalJerk,
    kpiPass: state.l1LongitudinalJerk.l1LongitudinalJerkKPI.kpiPass
})

export default connect(mapStateToProps, undefined)(LongitudinalJerkKPI);